// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"31d6cfe0","373":"31d6cfe0","388":"31d6cfe0","793":"31d6cfe0"}[chunkId] + ".chunk.css";
};